<div class=" container " >

    <div class="" style="height: 200px;">


        <h6 i18n>Reset password</h6>
        <div style="min-height: 400px" class="text-left p-t-10 p-b-5 " *ngIf="isResetSent == false">
            Please fill in your account email address.
            <form [formGroup]="form" (submit)="doPasswordReset();">


                <table>
                    <tr>
                        <td><input size="30"
                                placeholder="Email"
                                name="email" class="form-control" value="" formControlName="email"/></td>
                        <td><input  type="submit" class="btn btn-primary m-l-5" value="Reset"/></td>
                    </tr>
                </table>


            </form>

        </div>

        <div class="resetSent" *ngIf="isResetSent">

            <div>

                <h4><i class="la la-check-circle" style="font-size: 30px;color: green"></i> Password reset link was
                    sent successfully.</h4>
                <p>If you have provided the right username or email, please check your mail for further details on how
                    to
                    reset your password.</p>
            </div>

        </div>
    </div>

</div>
